import styled, { css } from 'styled-components';

import { defaultLinkStyle, purpurFocus } from '@telialt/common-theme/src/mixins';
import { getPurpurColor, getPurpurTypography, purpurMedia } from '@telialt/common-theme/src/purpurSelectors';

export const BurgerMenuContainer = styled.div`
    position: relative;
    height: 100%;
    display: flex;
    align-items: center;

    ${purpurMedia('lg')`
        display: none;
    `};
`;

type BurgerButtonProps = {
    $isOpen?: boolean;
};

export const StyledBurgerButton = styled.button<BurgerButtonProps>`
    color: inherit;
    background: transparent;
    border: 0;
    padding: 0;
    ${defaultLinkStyle()};
    display: flex;
    align-items: center;
    position: relative;
    font-size: ${getPurpurTypography('scale600')};

    ${purpurFocus()};

    ${(props) =>
        props.$isOpen &&
        css`
            color: ${getPurpurColor('purple500')};
        `};

    > span {
        display: flex;
    }
`;

export const MobileMenuWrapper = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
`;

export const MainMenuContainer = styled.div`
    flex: 1;
    overflow: hidden;
`;

export const ContextMenuContainer = styled.div`
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    height: 3rem;
    background: ${getPurpurColor('gray50')};
`;
